import {NativeModules} from 'react-native';

const {AndroidSoftInputMode} = NativeModules;

export default {
  setSoftInputMode: (
    mode: 
      | 'adjustResize' 
      | 'adjustPan' 
      | 'stateHidden|adjustPan' 
      | 'stateVisible|adjustPan'
      | 'stateVisible|adjustNothing'
  ) => AndroidSoftInputMode.setSoftInputMode(mode),
};
